import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../pwa/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_swplugin_4684c0fa from 'nuxt_plugin_swplugin_4684c0fa' // Source: ./sw.plugin.js (mode: 'client')
import nuxt_plugin_libplugin24fb8b24_9614258a from 'nuxt_plugin_libplugin24fb8b24_9614258a' // Source: ./lib.plugin.24fb8b24.js (mode: 'all')
import nuxt_plugin_axios_75cc583e from 'nuxt_plugin_axios_75cc583e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_i18n_559c2e38 from 'nuxt_plugin_i18n_559c2e38' // Source: ../../pwa/plugins/i18n (mode: 'all')
import nuxt_plugin_eventBus_8a8495aa from 'nuxt_plugin_eventBus_8a8495aa' // Source: ../../pwa/plugins/eventBus.js (mode: 'all')
import nuxt_plugin_materialize_7b8b8b50 from 'nuxt_plugin_materialize_7b8b8b50' // Source: ../../pwa/plugins/materialize.js (mode: 'all')
import nuxt_plugin_rentcarscdn_3c52048e from 'nuxt_plugin_rentcarscdn_3c52048e' // Source: ../../pwa/plugins/rentcars-cdn.js (mode: 'all')
import nuxt_plugin_rentcarsapi_41d7bea8 from 'nuxt_plugin_rentcarsapi_41d7bea8' // Source: ../../pwa/plugins/rentcars-api.js (mode: 'all')
import nuxt_plugin_promotionsapi_2e7f50d4 from 'nuxt_plugin_promotionsapi_2e7f50d4' // Source: ../../pwa/plugins/promotions-api.js (mode: 'all')
import nuxt_plugin_routeresolver_1ed419a7 from 'nuxt_plugin_routeresolver_1ed419a7' // Source: ../../pwa/plugins/route-resolver.js (mode: 'all')
import nuxt_plugin_veevalidate_b83c3a38 from 'nuxt_plugin_veevalidate_b83c3a38' // Source: ../../pwa/plugins/vee-validate.js (mode: 'all')
import nuxt_plugin_vuexroutersync_6e7be226 from 'nuxt_plugin_vuexroutersync_6e7be226' // Source: ../../pwa/plugins/vuex-router-sync.js (mode: 'all')
import nuxt_plugin_vuedatetime_b01ef762 from 'nuxt_plugin_vuedatetime_b01ef762' // Source: ../../pwa/plugins/vue-datetime.js (mode: 'all')
import nuxt_plugin_vuemask_0bf288be from 'nuxt_plugin_vuemask_0bf288be' // Source: ../../pwa/plugins/vue-mask.js (mode: 'all')
import nuxt_plugin_featureflagapi_40df8341 from 'nuxt_plugin_featureflagapi_40df8341' // Source: ../../pwa/plugins/feature-flag-api.js (mode: 'all')
import nuxt_plugin_locationapi_f3dd9fa2 from 'nuxt_plugin_locationapi_f3dd9fa2' // Source: ../../pwa/plugins/location-api.js (mode: 'all')
import nuxt_plugin_multistoreapi_6a86bebc from 'nuxt_plugin_multistoreapi_6a86bebc' // Source: ../../pwa/plugins/multistore-api.js (mode: 'all')
import nuxt_plugin_rest_19b89dc6 from 'nuxt_plugin_rest_19b89dc6' // Source: ../../pwa/plugins/rest.js (mode: 'all')
import nuxt_plugin_rentcarspublicapi_5dfbb8dc from 'nuxt_plugin_rentcarspublicapi_5dfbb8dc' // Source: ../../pwa/plugins/rentcars-public-api.js (mode: 'all')
import nuxt_plugin_faqapi_7db7ee7a from 'nuxt_plugin_faqapi_7db7ee7a' // Source: ../../pwa/plugins/faq-api.js (mode: 'all')
import nuxt_plugin_index_9d7db334 from 'nuxt_plugin_index_9d7db334' // Source: ../../pwa/helpers/index.js (mode: 'all')
import nuxt_plugin_cpfValidate_458ad789 from 'nuxt_plugin_cpfValidate_458ad789' // Source: ../../pwa/helpers/cpfValidate.js (mode: 'all')
import nuxt_plugin_treatTime_7422c6db from 'nuxt_plugin_treatTime_7422c6db' // Source: ../../pwa/filters/treatTime.js (mode: 'all')
import nuxt_plugin_onlyNumbers_35c4c5c4 from 'nuxt_plugin_onlyNumbers_35c4c5c4' // Source: ../../pwa/filters/onlyNumbers.js (mode: 'all')
import nuxt_plugin_phone_86d4f8d8 from 'nuxt_plugin_phone_86d4f8d8' // Source: ../../pwa/filters/phone.js (mode: 'all')
import nuxt_plugin_twoDigits_daead2a0 from 'nuxt_plugin_twoDigits_daead2a0' // Source: ../../pwa/filters/twoDigits.js (mode: 'all')
import nuxt_plugin_global_5fd467ee from 'nuxt_plugin_global_5fd467ee' // Source: ../../pwa/mixins/global.js (mode: 'all')
import nuxt_plugin_googlelogingsi_08b741cc from 'nuxt_plugin_googlelogingsi_08b741cc' // Source: ../../pwa/mixins/google-login-gsi.js (mode: 'all')
import nuxt_plugin_clickoutside_636cf9ab from 'nuxt_plugin_clickoutside_636cf9ab' // Source: ../../pwa/directives/click-outside.js (mode: 'all')
import nuxt_plugin_rentlazy_2a997f96 from 'nuxt_plugin_rentlazy_2a997f96' // Source: ../../pwa/plugins/rent-lazy.js (mode: 'all')
import nuxt_plugin_securevhtml_446d2705 from 'nuxt_plugin_securevhtml_446d2705' // Source: ../../pwa/plugins/secure-v-html.js (mode: 'all')
import nuxt_plugin_securevhref_408fff85 from 'nuxt_plugin_securevhref_408fff85' // Source: ../../pwa/plugins/secure-v-href.js (mode: 'all')
import nuxt_plugin_datadogclient_36cd43aa from 'nuxt_plugin_datadogclient_36cd43aa' // Source: ../../pwa/plugins/datadog.client.js (mode: 'client')
import nuxt_plugin_securevhtmltarget_78cadc6b from 'nuxt_plugin_securevhtmltarget_78cadc6b' // Source: ../../pwa/plugins/secure-v-html-target.js (mode: 'all')
import nuxt_plugin_vuecarousel_3ed7d84a from 'nuxt_plugin_vuecarousel_3ed7d84a' // Source: ../../pwa/plugins/vue-carousel.js (mode: 'client')
import nuxt_plugin_vuepagination_bcc501e0 from 'nuxt_plugin_vuepagination_bcc501e0' // Source: ../../pwa/plugins/vue-pagination.js (mode: 'client')
import nuxt_plugin_lazyload_07b9ebd7 from 'nuxt_plugin_lazyload_07b9ebd7' // Source: ../../pwa/plugins/lazyload.js (mode: 'client')
import nuxt_plugin_select2_75f6e472 from 'nuxt_plugin_select2_75f6e472' // Source: ../../pwa/plugins/select2.js (mode: 'client')
import nuxt_plugin_cookie_380cc20d from 'nuxt_plugin_cookie_380cc20d' // Source: ../../pwa/plugins/cookie.js (mode: 'client')
import nuxt_plugin_storage_5851e3e2 from 'nuxt_plugin_storage_5851e3e2' // Source: ../../pwa/plugins/storage.js (mode: 'client')
import nuxt_plugin_rentcarsdatalayer_6028c84c from 'nuxt_plugin_rentcarsdatalayer_6028c84c' // Source: ../../pwa/plugins/rentcars-data-layer.js (mode: 'client')
import nuxt_plugin_webfontloader_120db0e5 from 'nuxt_plugin_webfontloader_120db0e5' // Source: ../../pwa/plugins/web-font-loader.js (mode: 'client')
import nuxt_plugin_firstaccess_0053a6a0 from 'nuxt_plugin_firstaccess_0053a6a0' // Source: ../../pwa/plugins/first-access.js (mode: 'client')
import nuxt_plugin_setdevicetype_61f9f117 from 'nuxt_plugin_setdevicetype_61f9f117' // Source: ../../pwa/plugins/set-device-type.js (mode: 'client')
import nuxt_plugin_vueawesomeswiper_5ce03f58 from 'nuxt_plugin_vueawesomeswiper_5ce03f58' // Source: ../../pwa/plugins/vue-awesome-swiper.js (mode: 'client')
import nuxt_plugin_gdpr_a941c51c from 'nuxt_plugin_gdpr_a941c51c' // Source: ../../pwa/plugins/gdpr.js (mode: 'client')
import nuxt_plugin_googlegclid_5a22070c from 'nuxt_plugin_googlegclid_5a22070c' // Source: ../../pwa/plugins/google-gclid.js (mode: 'client')
import nuxt_plugin_uuidcookie_4146bcc7 from 'nuxt_plugin_uuidcookie_4146bcc7' // Source: ../../pwa/plugins/uuid-cookie.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"name":"theme-color","content":"#fba617"},{"name":"apple-mobile-web-app-title","content":"Rentcars.com"},{"name":"apple-mobile-web-app-status-bar-style","content":"default"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"name":"referrer","content":"no-referrer-when-downgrade"},{"name":"google-signin-client_id","content":"249486929087-6eivg9p0es2nji563po57nod1ch9fpik.apps.googleusercontent.com"},{"name":"google-signin-scope","content":"profile email"},{"name":"google-site-verification","content":"8pTAKsyZLYDnaKoXDqbDfM73IJFbDd8zcPEoRXofzSY"},{"property":"og:site_name","content":"Rentcars.com"},{"property":"og:type","content":"website"},{"property":"fb:admins","content":"100001011035051"},{"property":"fb:app_id","content":"288868037935831"},{"property":"og:image:type","content":"image\u002Fjpeg"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"628"},{"name":"application-name","content":"Rentcars.com"},{"name":"msapplication-starturl","content":"\u002F"},{"name":"msapplication-TileColor","content":"#FFFFFF"},{"name":"msapplication-square70x70logo","content":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Fwindows\u002Ftinylogo.png"},{"name":"msapplication-square150x150logo","content":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Fwindows\u002Flogo.png"},{"name":"msapplication-wide310x150logo","content":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Fwindows\u002Fwidelogo.png"},{"name":"msapplication-square310x310logo","content":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Fwindows\u002Flargelogo.png"},{"name":"msapplication-TileColor","content":"#FFFFFF"},{"name":"apple-itunes-app","content":"app-id=918167519"},{"hid":"author","name":"author","content":"Rentcars.com &lt;produto@rentcars.com&gt;"},{"hid":"description","name":"description","content":"Rentcars.com - PWA"},{"hid":"og:title","name":"og:title","property":"og:title","content":"Rentcars.com"},{"hid":"og:description","name":"og:description","property":"og:description","content":"Rentcars.com - PWA"}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Ffavicon\u002Ffavicon-16x16.png","sizes":"16x16"},{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Ffavicon\u002Ffavicon-24x24.png","sizes":"24x24"},{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Ffavicon\u002Ffavicon-32x32.png","sizes":"32x32"},{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Ffavicon\u002Ffavicon-64x64.png","sizes":"64x64"},{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Ffavicon\u002Ffavicon-72x72.png","sizes":"72x72"},{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Ffavicon\u002Ffavicon-96x96.png","sizes":"96x96"},{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Ffavicon\u002Ffavicon-128x128.png","sizes":"128x128"},{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Ffavicon\u002Ffavicon-192x192.png","sizes":"192x192"},{"rel":"icon","type":"image\u002Fpng","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Ffavicon\u002Ffavicon-256x256.png","sizes":"256x256"},{"rel":"mask-icon","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Ffavicon\u002Ffavicon-16x16.png","color":"#fba617"},{"rel":"apple-touch-icon","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Fapple\u002Ftouch-icon-rentcars.png"},{"rel":"apple-touch-icon","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Fapple\u002Ftouch-icon-rentcars-76.png","sizes":"76x76"},{"rel":"apple-touch-icon","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Fapple\u002Fiphone-120px.png","sizes":"120x120"},{"rel":"apple-touch-icon","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Fapple\u002Fipad-mini-152px.png","sizes":"152x152"},{"rel":"apple-touch-icon","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Fapple\u002Fipad-pro-167px.png","sizes":"167x167"},{"rel":"apple-touch-icon","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Fapple\u002Fiphone-180px.png","sizes":"180x180"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fstatic-rentcars-cdn.rentcars.com"},{"rel":"preconnect","href":"https:\u002F\u002Fstatic-mobile-cdn.rentcars.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fpromotions.rentcars.com"},{"rel":"dns-prefetch","href":"https:\u002F\u002Ffacade.rentcars.com"},{"rel":"dns-prefetch","href":"fonts.googleapis.com"},{"rel":"dns-prefetch","href":"fonts.gstatic.com","crossorigin":true},{"rel":"preload","as":"font","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Finter\u002Fv19\u002FUcC73FwrK3iLTeHuS_nVMrMxCp50SjIa0ZL7SUc.woff2","type":"font\u002Fwoff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Finter\u002Fv19\u002FUcC73FwrK3iLTeHuS_nVMrMxCp50SjIa0ZL7SUc500.woff2","type":"font\u002Fwoff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Finter\u002Fv19\u002FUcC73FwrK3iLTeHuS_nVMrMxCp50SjIa0ZL7SUc600.woff2","type":"font\u002Fwoff2","crossorigin":"anonymous"},{"rel":"preload","as":"font","href":"https:\u002F\u002Ffonts.gstatic.com\u002Fs\u002Finter\u002Fv19\u002FUcC73FwrK3iLTeHuS_nVMrMxCp50SjIa0ZL7SUc700.woff2","type":"font\u002Fwoff2","crossorigin":"anonymous"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Inter:wght@400;500;600;700&display=swap","onload":"if(media!='all')media='all'","body":true},{"rel":"manifest","href":"\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fdist\u002Fpwa\u002Fdist\u002Fclient\u002Fmanifest.aee7abda.json"},{"rel":"shortcut icon","href":"\u002F\u002Fstatic-mobile-cdn.rentcars.com\u002Fimages\u002Ficons\u002Fandroid\u002F36x36.png"}],"script":[{"src":"\u002Fjs\u002Fworldpay-cse-1.0.1.min.js","type":"text\u002Fjavascript","defer":true,"body":true},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=152079398","defer":true},{"src":"\u002F\u002Fwidget.trustpilot.com\u002Fbootstrap\u002Fv5\u002Ftp.widget.bootstrap.min.js","type":"text\u002Fjavascript","defer":true,"body":true}],"style":[],"title":"Rentcars.com","htmlAttrs":{"lang":"en"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_swplugin_4684c0fa === 'function') {
    await nuxt_plugin_swplugin_4684c0fa(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin24fb8b24_9614258a === 'function') {
    await nuxt_plugin_libplugin24fb8b24_9614258a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_75cc583e === 'function') {
    await nuxt_plugin_axios_75cc583e(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_559c2e38 === 'function') {
    await nuxt_plugin_i18n_559c2e38(app.context, inject)
  }

  if (typeof nuxt_plugin_eventBus_8a8495aa === 'function') {
    await nuxt_plugin_eventBus_8a8495aa(app.context, inject)
  }

  if (typeof nuxt_plugin_materialize_7b8b8b50 === 'function') {
    await nuxt_plugin_materialize_7b8b8b50(app.context, inject)
  }

  if (typeof nuxt_plugin_rentcarscdn_3c52048e === 'function') {
    await nuxt_plugin_rentcarscdn_3c52048e(app.context, inject)
  }

  if (typeof nuxt_plugin_rentcarsapi_41d7bea8 === 'function') {
    await nuxt_plugin_rentcarsapi_41d7bea8(app.context, inject)
  }

  if (typeof nuxt_plugin_promotionsapi_2e7f50d4 === 'function') {
    await nuxt_plugin_promotionsapi_2e7f50d4(app.context, inject)
  }

  if (typeof nuxt_plugin_routeresolver_1ed419a7 === 'function') {
    await nuxt_plugin_routeresolver_1ed419a7(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_b83c3a38 === 'function') {
    await nuxt_plugin_veevalidate_b83c3a38(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexroutersync_6e7be226 === 'function') {
    await nuxt_plugin_vuexroutersync_6e7be226(app.context, inject)
  }

  if (typeof nuxt_plugin_vuedatetime_b01ef762 === 'function') {
    await nuxt_plugin_vuedatetime_b01ef762(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemask_0bf288be === 'function') {
    await nuxt_plugin_vuemask_0bf288be(app.context, inject)
  }

  if (typeof nuxt_plugin_featureflagapi_40df8341 === 'function') {
    await nuxt_plugin_featureflagapi_40df8341(app.context, inject)
  }

  if (typeof nuxt_plugin_locationapi_f3dd9fa2 === 'function') {
    await nuxt_plugin_locationapi_f3dd9fa2(app.context, inject)
  }

  if (typeof nuxt_plugin_multistoreapi_6a86bebc === 'function') {
    await nuxt_plugin_multistoreapi_6a86bebc(app.context, inject)
  }

  if (typeof nuxt_plugin_rest_19b89dc6 === 'function') {
    await nuxt_plugin_rest_19b89dc6(app.context, inject)
  }

  if (typeof nuxt_plugin_rentcarspublicapi_5dfbb8dc === 'function') {
    await nuxt_plugin_rentcarspublicapi_5dfbb8dc(app.context, inject)
  }

  if (typeof nuxt_plugin_faqapi_7db7ee7a === 'function') {
    await nuxt_plugin_faqapi_7db7ee7a(app.context, inject)
  }

  if (typeof nuxt_plugin_index_9d7db334 === 'function') {
    await nuxt_plugin_index_9d7db334(app.context, inject)
  }

  if (typeof nuxt_plugin_cpfValidate_458ad789 === 'function') {
    await nuxt_plugin_cpfValidate_458ad789(app.context, inject)
  }

  if (typeof nuxt_plugin_treatTime_7422c6db === 'function') {
    await nuxt_plugin_treatTime_7422c6db(app.context, inject)
  }

  if (typeof nuxt_plugin_onlyNumbers_35c4c5c4 === 'function') {
    await nuxt_plugin_onlyNumbers_35c4c5c4(app.context, inject)
  }

  if (typeof nuxt_plugin_phone_86d4f8d8 === 'function') {
    await nuxt_plugin_phone_86d4f8d8(app.context, inject)
  }

  if (typeof nuxt_plugin_twoDigits_daead2a0 === 'function') {
    await nuxt_plugin_twoDigits_daead2a0(app.context, inject)
  }

  if (typeof nuxt_plugin_global_5fd467ee === 'function') {
    await nuxt_plugin_global_5fd467ee(app.context, inject)
  }

  if (typeof nuxt_plugin_googlelogingsi_08b741cc === 'function') {
    await nuxt_plugin_googlelogingsi_08b741cc(app.context, inject)
  }

  if (typeof nuxt_plugin_clickoutside_636cf9ab === 'function') {
    await nuxt_plugin_clickoutside_636cf9ab(app.context, inject)
  }

  if (typeof nuxt_plugin_rentlazy_2a997f96 === 'function') {
    await nuxt_plugin_rentlazy_2a997f96(app.context, inject)
  }

  if (typeof nuxt_plugin_securevhtml_446d2705 === 'function') {
    await nuxt_plugin_securevhtml_446d2705(app.context, inject)
  }

  if (typeof nuxt_plugin_securevhref_408fff85 === 'function') {
    await nuxt_plugin_securevhref_408fff85(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datadogclient_36cd43aa === 'function') {
    await nuxt_plugin_datadogclient_36cd43aa(app.context, inject)
  }

  if (typeof nuxt_plugin_securevhtmltarget_78cadc6b === 'function') {
    await nuxt_plugin_securevhtmltarget_78cadc6b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecarousel_3ed7d84a === 'function') {
    await nuxt_plugin_vuecarousel_3ed7d84a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuepagination_bcc501e0 === 'function') {
    await nuxt_plugin_vuepagination_bcc501e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazyload_07b9ebd7 === 'function') {
    await nuxt_plugin_lazyload_07b9ebd7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_select2_75f6e472 === 'function') {
    await nuxt_plugin_select2_75f6e472(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookie_380cc20d === 'function') {
    await nuxt_plugin_cookie_380cc20d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_storage_5851e3e2 === 'function') {
    await nuxt_plugin_storage_5851e3e2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_rentcarsdatalayer_6028c84c === 'function') {
    await nuxt_plugin_rentcarsdatalayer_6028c84c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webfontloader_120db0e5 === 'function') {
    await nuxt_plugin_webfontloader_120db0e5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_firstaccess_0053a6a0 === 'function') {
    await nuxt_plugin_firstaccess_0053a6a0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_setdevicetype_61f9f117 === 'function') {
    await nuxt_plugin_setdevicetype_61f9f117(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_5ce03f58 === 'function') {
    await nuxt_plugin_vueawesomeswiper_5ce03f58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gdpr_a941c51c === 'function') {
    await nuxt_plugin_gdpr_a941c51c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlegclid_5a22070c === 'function') {
    await nuxt_plugin_googlegclid_5a22070c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_uuidcookie_4146bcc7 === 'function') {
    await nuxt_plugin_uuidcookie_4146bcc7(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
